export const validateRegex = {
  validateNumber: new RegExp(/^\d*\.?\d*$/),
  validateLetters: new RegExp(/^[a-zA-Z\s]*$/),
  validateEmail: new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/),
}
